import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateDisableVacancyList = {
  disableVacancyList: { data: null, loading: false, error: null },
};

export const disableVacancyList = createAsyncThunk('user/disableVacancyList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/vacancies/broadcast`,
      { is_broadcast: false, vacancies: data },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerDisableVacancyList = {
  [disableVacancyList.pending]: (state) => {
    state.disableVacancyList.loading = true;
    state.disableVacancyList.error = null;
  },
  [disableVacancyList.fulfilled]: (state, action) => {
    state.disableVacancyList.loading = false;
    state.disableVacancyList.data = true;
    state.disableVacancyList.error = null;
  },
  [disableVacancyList.rejected]: (state, action) => {
    state.disableVacancyList.loading = false;
    state.disableVacancyList.error = action.payload;
  },
};
